export default __webpack_public_path__ + "static/bg-header-7fe546244bfcb0649c1367729eb15436.jpeg";